import { Context } from "../Engine";
import { ImageResource } from "@spi/Common/Collada/ImageResource";
import { ITexture } from "./ITexture";

export class ColladaTexture implements ITexture {
    public glTexture: WebGLTexture;
    public translucent: boolean;

    constructor() {
        this.glTexture = null;
        this.translucent = false;
    }

    public async loadColladaTexture(ctx: Context, colladaImage: ImageResource) {
        let gl = ctx.gl;
        let texture = gl.createTexture();
        this.glTexture = texture;

        let imageData = await ctx.resourceLoader.loadImageData(new Uint8Array(colladaImage.alignedBuffer), colladaImage.imageType);

        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, imageData.width, imageData.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, imageData.data);

        // Make texture options dependant on settings levels

        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);

        gl.generateMipmap(gl.TEXTURE_2D);

        gl.bindTexture(gl.TEXTURE_2D, null);
    }
}